import React, { useEffect, useState } from 'react';
const API_BASE = process.env.REACT_APP_API_URL || '';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Tabs,
  Tab,
} from '@mui/material';

export const LoginLogTable = () => {
  const [logs, setLogs] = useState([]);
  const [failedAttempts, setFailedAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const [loginRes, failedRes] = await Promise.all([
          fetch(`${API_BASE}/api/admin/login-logs`),
          fetch(`${API_BASE}/api/admin/failed-login-attempts`),
        ]);
        const loginData = await loginRes.json();
        const failedData = await failedRes.json();
        setLogs(loginData);
        setFailedAttempts(failedData);
      } catch (err) {
        console.error('Failed to fetch logs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box p={4} maxWidth="1000px" mx="auto">
      <Tabs value={tab} onChange={handleTabChange} centered sx={{ mb: 4 }}>
        <Tab label="Login Activity" />
        <Tab label="Failed Attempts" />
      </Tabs>

      {loading ? (
        <Box display="flex" justifyContent="center" my={8}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {tab === 0 && (
            <>
              <Typography variant="h5" fontWeight={600} gutterBottom color="primary">
                👤 Login Activity Logs
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={3}>
                The table below shows the 100 most recent login activities.
              </Typography>
              <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Username</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Login Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logs.map((log, index) => (
                      <TableRow key={index}>
                        <TableCell>{log.username || '—'}</TableCell>
                        <TableCell>{log.email || '—'}</TableCell>
                        <TableCell>
                          {new Date(log.time).toLocaleString('en-US', {
                            timeZone: 'Asia/Phnom_Penh',
                            hour12: false,
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {tab === 1 && (
            <>
              <Typography variant="h6" fontWeight={600} gutterBottom color="error">
                🚨 Failed Login Attempts
              </Typography>
              <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: '#fff3f3' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Username</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>IP Address</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Timestamp</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {failedAttempts.map((fail, index) => (
                      <TableRow key={index}>
                        <TableCell>{fail.username || '—'}</TableCell>
                        <TableCell>{fail.ip || '—'}</TableCell>
                        <TableCell>
                          {new Date(fail.timestamp).toLocaleString('en-US', {
                            timeZone: 'Asia/Phnom_Penh',
                            hour12: false,
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </>
      )}
    </Box>
  );
};